import { AxiosRequestConfig, Method } from 'axios'

import { useAxiosInstance } from './AxiosInstanceProvider.js'

export function createDownloadLink(data: BlobPart, filename: string): void {
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(new Blob([data]))
  link.setAttribute('download', filename)
  link.setAttribute('target', '__blank')
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const useDownload = () => {
  const axiosInstance = useAxiosInstance()

  return {
    triggerDownload: (url: string, filename: string, body?: {}, method?: Method): Promise<void> => {
      const request: AxiosRequestConfig = {
        responseType: 'blob',
        url,
        method,
        data: body,
      }

      return axiosInstance.request<BlobPart>(request).then((resp) => {
        if (resp?.data) {
          createDownloadLink(resp.data, filename)
        }
      })
    },
  }
}
